<script setup>
import {ref, computed, onMounted, onBeforeUnmount, getCurrentInstance, watch, defineExpose} from 'vue'
import {onBeforeRouteLeave, useRoute, useRouter} from 'vue-router'
import _ from 'lodash'
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import { useUserStore } from "../../../stores/user";
import { useSiteMenuStore } from "../../../../../stores/sitemenu";
import SNB from '../../../../../layouts/nav/SNB.vue'
import KSAInputNumber from "../../../../../components/ui-components/input/KSAInputNumber.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import jobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import JobFairCorpService from "@/pages/user/services/jobFair/jobFairCorpService";
import { useAlertStore } from '../../../../../stores/alertStore';
const { $alert, $confirm } = useAlertStore();

const route = useRoute();
const router = useRouter()
const globals = getCurrentInstance().appContext.config.globalProperties;
const { $toast, $gb } = globals;
const loadingStore = usePageLoadingStore()
const userStore = useUserStore()
const isStudent = ref(true);

const ojfId = ref(route.query.ojfId || '');
const resumeId = ref(route.query.resumeId || ''); // 면접제안 등록을 위한 데이터 (resumeId가 있으면 등록완료 시 면접제안 팝업 띄움)
const recruitmentHallSeq = ref(route.query.recruitmentHallSeq || '');
const mode = ref(route.query.mode || '');

let clickLogout = false; // 로그아웃 클릭 여부
const siteMenuStore = useSiteMenuStore();

let isSaved = false; // 저장 여부

// 페이지 이탈
if (mode.value === 'corpRecruitmentHall') {
  onBeforeRouteLeave(async (to, from, next) => {
    if(to.path !== "mypage/corpJobFair/jobNoticeCreat" && to.path.startsWith("mypage/corpJobFair/jobNoticeCreat")) {
      next();
    } else if (isSaved) {
      next();
    } else {
      if(!clickLogout) {
        const ok = await $confirm(["페이지를 나가겠습니까?", "페이지 이동 시 입력한 정보는 저장되지 않습니다"], "확인", "취소");
        if(ok) {
          next();
        } else {
          // 사용자가 취소를 선택한 경우 navigation을 중단
          next(false);
        }
      } else {
        // clickLogout이 true인 경우 navigation 허용
        next();
      }
    }
  })
}

// 브라우저 닫기/새로고침 이벤트 핸들러
const handleBeforeUnload = (event) => {

};

// 로그아웃버튼 클릭 이벤트 핸들러
const handleClickLogout = async (event) => {
  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation(); // 같은 요소의 다른 이벤트 리스너 실행 방지
  
  clickLogout = true;

  const ok = await $confirm(["페이지를 나가겠습니까?", "페이지 이동 시 입력한 정보는 저장되지 않습니다"], "확인", "취소");
  if(ok) {
    userStore.setUser({});
    siteMenuStore.getSiteMenu()
    router.push({name: 'Home', query: { logout: 'true' }});
  } else {
    clickLogout = false;
  }
  
  // 추가적으로 Header의 logout 함수 실행을 완전히 방지
  return false;
};

const tabList = ref([
  { title: '기본 정보', active: true, completed: false, closed: false },
  { title: '소개', active: false, completed: false, closed: false },
  { title: '학력', active: false, completed: false, closed: false },
  { title: '포트폴리오', active: false, completed: false, closed: false },
  { title: '자격증 및 외국어', active: false, completed: false, closed: false },
  { title: '업무 경험', active: false, completed: false, closed: false },
  { title: '병역', active: false, completed: false, closed: false },
])

const saveIsDisabled = ref(false)

onMounted(()=> {
  const { id } = route.params;

  if(userStore.user.userGb !== '01' && userStore.user.userGb !== 'STUDENT') {
    isStudent.value = false;
  }

  _.each(data_interests.value, el => {el.on = false;})
  _.each(data_job.value, el => {el.on = false;})
  _.each(data_jobExperience.value, el => {el.on = false;})
  _.each(data_workType.value, el => {el.on = false;})

  // 브라우저 닫기/새로고침 이벤트 리스너 등록
  window.addEventListener('beforeunload', handleBeforeUnload);

  // 로그아웃 버튼 이벤트 리스너를 캡처링 단계에서 등록하여 우선 실행되도록 함
  let logoutBtn = document.querySelector('.btn-logout');
  if(logoutBtn) {
    // 기존 이벤트 리스너 제거 (Header에서 등록된 것)
    logoutBtn.removeEventListener('click', logoutBtn.onclick);
    // 캡처링 단계에서 이벤트 리스너 등록 (true 옵션)
    logoutBtn.addEventListener('click', handleClickLogout, true);
  }

  // 저장 비활성화
  //saveIsDisabled.value = Number(moment().format('YYYYMMDD')) >= 20230527;
})

// 컴포넌트 언마운트 시 이벤트 리스너 정리
onBeforeUnmount(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload);
  let logoutBtn = document.querySelector('.btn-logout');
  if(logoutBtn) {
     // 캡처링 단계에서 등록한 이벤트 리스너 제거
     logoutBtn.removeEventListener('click', handleClickLogout, true);
  }
});

const currentTabIndex = computed(()=>{
  return _.findIndex(tabList.value, {'active': true});
})

const residenceAreaRef = ref(null);
const schoolGbRef = ref(null);
const salaryGbRef = ref(null);
const salaryRef = ref(null);

const jobNoticeCreate = ref({
  "ojfId": 0,
  "jobName": '', // 채용공고명
  "interests": '', // 관심카테고리
  "job": '', // 직무
  "recruitArea": '', // 모집분야명
  "recruitCnt": 0, // 모집인원
  "jobExperience": '', //  경력
  "schoolGb": '', // 학력 05 고졸 01 대학(2,3년) 02 대학(4년) 03 대학원(석사) 04 대학원(박사)
  "specialTreat": '', // 우대사항(자격증)
  "workArea1": '', // 근무지역_시도
  "workArea2": '', // 근무지역_시군구
  "workHomeYn": 'N', // 재택가능여부
  "workType": '', // 근무형태
  "salaryGb": '01', // 급여구분
  "salary": 0, // 급여
  "note": '<strong>[전형단계]</strong><br>' +
    '<span style="color:hsl(0, 0%, 70%);">예시)</span><br>' +
    '<span style="color:hsl(0, 0%, 70%);">①지원서 접수</span><br>' +
    '<span style="color:hsl(0, 0%, 70%);">②서류전형</span><br>' +
    '<span style="color:hsl(0, 0%, 70%);">③1차면접</span><br>' +
    '<span style="color:hsl(0, 0%, 70%);">④2차면접</span><br>' +
    '<span style="color:hsl(0, 0%, 70%);">⑤채용검진</span><br>' +
    '<span style="color:hsl(0, 0%, 70%);">⑥최종합격</span><br>' +
    '<br>' +
    '<strong>[기타]</strong><br>' +
    '<span style="color:hsl(0, 0%, 70%);">예시)</span><br>' +
    '<span style="color:hsl(0, 0%, 70%);">-최종 합격 후, 회사가 지정하는 입사일에 입사 불가할 경우 합격이 취소되거나 전형상의 불이익이 있을 수 있습니다.</span><br>' +
    '<span style="color:hsl(0, 0%, 70%);">-지원서를 포함하여 채용 전형 진행 중 모든 과정에서 제출한 내용이 사실과 다르거나 문서로 증빙이 불가할 경우 합격이 취소되거나 전형상의 불이익이 있을 수 있습니다.</span><br>'
  , // 기타 요건
})

const inputError = ref({
  jobName: '', // 채용공고명
  interests: '', // 관심카테고리
  job: '', // 직무
  recruitArea: '',// 모집분야명
  recruitCnt: '', // 모집인원
  jobExperience: '', //  경력
  schoolGb: '', // 학력
  specialTreat: '', // 우대사항(자격증)
  workArea: '', // 근무지역
  workType: '', // 근무형태
  salary: '', // 급여구분
})

const data_interests = ref(globals.$interests) // 관심 카테고리
const data_job = ref(globals.$desiredJob) // 직무
const data_jobExperience = ref(globals.$jobExperience) // 경력
const data_workType = ref(globals.$workType) // 근무형태

// 관심 카테고리
const interestCount = computed(()=>{
  return _.filter(data_interests.value, {'on': true}).length || 0;
})

const onClickInterest = (interest) => {
  inputError.value.interests = '';
  if(interest.on) {
    interest.on  = false;
  } else {
    if(interestCount.value < 3) {
      interest.on = true;
    } else {
      inputError.value.interests = '최대 3개까지 선택할 수 있습니다.';
    }
  }
}

// 직무
const onClickJob = (job) => {
  inputError.value.job = '';
  if(job.on) {
    job.on  = false;
  } else {
    job.on = true;
  }
}

// 경력
const onClickJobExperience = (jobExperience) => {
  inputError.value.jobExperience = '';
  if(jobExperience.on) {
    jobExperience.on  = false;
  } else {
    jobExperience.on = true;
  }
}

// 근무지역
const onSelectedWorkArea1 = (option) => {
  jobNoticeCreate.value.workArea1 = option;
  inputError.value.workArea = '';
}

const onSelectedWorkArea2 = (option) => {
  jobNoticeCreate.value.workArea2 = option;
  inputError.value.workArea = '';
}

const onClickWorkHomeYn = (select) => {
  inputError.value.workArea = '';
  if(select === 'Y') {
    jobNoticeCreate.value.workHomeYn = 'N';
  } else {
    jobNoticeCreate.value.workHomeYn = 'Y';
  }
}

// 근무형태
const onClickWorkType = (selectedWorkType) => {
  inputError.value.workType = '';
  data_workType.value.forEach(item => {
    item.on = (item === selectedWorkType);
  });
}

const initSelectGbRefs = () => {
  setTimeout(()=>{
    if (currentTabIndex.value === 2) { // 학력
      for(let i=0; i<schoolGbRefs.value.length; i++) {
        schoolGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<majorGbRefs.value.length; i++) {
        majorGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<submajorTypeGbRefs.value.length; i++) {
        submajorTypeGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<submajorGbRefs.value.length; i++) {
        submajorGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<eduTenureGbRefs.value.length; i++) {
        eduTenureGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<fullScoreGbRefs.value.length; i++) {
        fullScoreGbRefs.value[i].initSelectedOption();
      }
    } else if (currentTabIndex.value === 4) { // 자격증및외국어
      for(let i=0; i<langGbRefs.value.length; i++) {
        langGbRefs.value[i].initSelectedOption();
      }
      for(let i=0; i<langLevelGbRefs.value.length; i++) {
        langLevelGbRefs.value[i].initSelectedOption();
      }
    }
  }, 100)
}

// 공고 등록
const saveJobNotice = (ojfId) => {
  clearErrorFocus();
  // 이미 저장 처리 중이면 재호출 방지
  if (saveIsDisabled.value) {
    return;
  }
  // 저장 처리 동안 버튼 비활성화
  saveIsDisabled.value = true;

  let isInvalid = false;

  const ojfIdNum = Number(ojfId);
  if (!Number.isInteger(ojfIdNum) || ojfIdNum <= 0) {
    $toast("error", "행사 식별자가 올바르지 않습니다.");
    saveIsDisabled.value = false;
    return;
  }

  // 공고 제목 저장
  const { jobName } = jobNoticeCreate.value;
  inputError.value.jobName = '';

  const jobNameTrim = jobName ? jobName.trim() : '';
  if(!jobNameTrim) {
    inputError.value.jobName = '공고 제목을 입력하세요.';
    isInvalid = true;
  } else if (jobNameTrim.length > 50) {
    inputError.value.jobName = '공고 제목은 최대 50자입니다.';
    isInvalid = true;
  }

  // 모집 분야
  const interests = _.map(_.filter(data_interests.value, {'on': true}), 'value').join(',');
  const job = _.map(_.filter(data_job.value, {'on': true}), 'value').join(',');
  const { recruitArea, recruitCnt } = jobNoticeCreate.value;

  inputError.value.interests = '';
  inputError.value.job = '';
  inputError.value.recruitArea = '';
  inputError.value.recruitCnt = '';

  if(!interests) {
    inputError.value.interests = '관심 카테고리를 선택하세요.';
    isInvalid = true;
  } else if (interests.length > 200) {
    $toast('error', '관심 카테고리가 너무 깁니다.');
    isInvalid = true;
  }

  if(!job) {
    inputError.value.job = '직무를 선택하세요.';
    isInvalid = true;
  } else if (job.length > 200) {
    $toast('error', '직무 선택 값이 너무 깁니다.');
    isInvalid = true;
  }

  const recruitAreaTrim = recruitArea ? recruitArea.trim() : '';
  if (!recruitAreaTrim) {
    inputError.value.recruitArea = '모집분야명을 입력하세요.';
    isInvalid = true;
  } else if (recruitAreaTrim.length > 50) {
    inputError.value.recruitArea = '모집분야명은 최대 50자입니다.';
    isInvalid = true;
  }

  const recruitCntNum = Number(recruitCnt);
  if (!Number.isInteger(recruitCntNum) || recruitCntNum <= 0) {
    inputError.value.recruitCnt = '모집인원은 1명 이상이어야 합니다.';
    isInvalid = true;
  }

  // 지원 자격 / 근무조건
  const jobExperience = _.map(_.filter(data_jobExperience.value, {'on': true}), 'value').join(',');
  const workType = _.map(_.filter(data_workType.value, {'on': true}), 'value').join(',');
  const {schoolGb, specialTreat, workArea1, workArea2, workHomeYn, salaryGb, note } = jobNoticeCreate.value;

  if (!jobExperience) {
    inputError.value.jobExperience = '경력을 선택하세요.';
    isInvalid = true;
  } else if (jobExperience.length > 10) {
    inputError.value.jobExperience = '경력 값은 최대 10자입니다.';
    isInvalid = true;
  }

  if (!schoolGb) {
    inputError.value.schoolGb = '학력을 선택하세요.';
    isInvalid = true;
  } else if (schoolGb.length > 2) {
    inputError.value.schoolGb = '학력 값은 최대 2자입니다.';
    isInvalid = true;
  }

  const specialTreatTrim = specialTreat ? specialTreat.trim() : '';
  if (!specialTreatTrim) {
    inputError.value.specialTreat = '우대 사항을 입력하세요.';
    isInvalid = true;
  } else if (specialTreatTrim.length > 50) {
    inputError.value.specialTreat = '우대 사항은 최대 50자입니다.';
    isInvalid = true;
  }

  const workArea1Trim = workArea1 ? workArea1.trim() : '';
  const workArea2Trim = workArea2 ? workArea2.trim() : '';
  // "시/도 선택" 문구는 빈값으로 처리
  const workArea1Clean = workArea1Trim === '시/도 선택' ? '' : workArea1Trim;
  const workArea2Clean = workArea2Trim === '시/구/군 선택' ? '' : workArea2Trim;
  const area1filter = !workArea1Clean;
  const area2filter = !workArea2Clean;

  if (!workHomeYn || workHomeYn === 'N' && (area1filter || area2filter)) {
    inputError.value.workArea = '근무지역을 선택하세요.';
    isInvalid = true;
  } else {
    inputError.value.workArea = '';
  }

  if (!workType) {
    inputError.value.workType = '근무형태를 선택하세요.';
    isInvalid = true;
  } else if (workType.length > 10) {
    inputError.value.workType = '근무형태 값은 최대 10자입니다.';
    isInvalid = true;
  }

  let salary = jobNoticeCreate.value.salary;

  if (salaryGb === '01') {
    if (!salary) {
      salary = 0;
    }
  } else if (salaryGb !== '01') {
    const salaryNum = Number(salary);
    if (!Number.isInteger(salaryNum) || salaryNum <= 0) {
      inputError.value.salary = '급여를 입력하세요.';
      isInvalid = true;
    } else if (String(salaryNum).length > 6) {
      inputError.value.salary = '급여는 최대 6자리까지 입력 가능합니다.';
      isInvalid = true;
    }
    salary = salaryNum;
  }

  if (!salaryGb || salaryGb.length > 2) {
    inputError.value.salary = '급여구분을 선택하세요.';
    isInvalid = true;
  }

  // if (note && String(note).length > 4000) {
  //   $toast('error', '기타요건은 최대 4000자까지 입력 가능합니다.');
  //   isInvalid = true;
  // }

  // 채용공고 등록
  const createJobNotice = () => {
    loadingStore.loading = true;

    jobFairCorpService.ojfCropJobNoticeCreate(
      ojfIdNum, jobNameTrim,
      interests, job, recruitAreaTrim, recruitCntNum,
      jobExperience, schoolGb, specialTreatTrim,
      workArea1Clean, workArea2Clean, workHomeYn, workType,
      salaryGb, salary, note,
    ).then(async (res) => {
      loadingStore.loading = false;

      if (res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;

        const ojfCropInterviewProposalCreate = async () => {
          const ok = await $confirm(["채용공고 등록이 완료되었습니다.", "해당 채용공고로 면접제안을 하시겠습니까?"], "면접제안", "취소");
          if (ok) {
            const paramObj = {
              ojfId: ojfId,
              resumeId: resumeId.value,
              jobNoticeSeq: result,
            };

            loadingStore.loading = true;
            jobFairCorpService.ojfCropInterviewProposalCreate(paramObj)
                .then(async (res) => {
                  loadingStore.loading = false;
                  if (res.data.code.toLowerCase() === 'success') {
                    $alert("면접제안을 하였습니다.");
                    let target = 'MatchingJobFairDetail';
                    if (mode.value === 'mypage') {
                      target = 'MyPageCorpJobFairDetail';
                    } else if (mode.value === 'openRecruitment') {
                      target = 'MyPageCorpOpenRecruitmentDetail';
                    }
                    router.push({name: target, params: {id: ojfId}});
                  } else {
                    $alert("면접제안을 실패하였습니다.");
                  }
                })
                .catch(async (error) => {
                  loadingStore.loading = false;
                  $alert("제안을 실패하였습니다.");
                });
          } else {
            let target = 'MatchingJobFairDetail';
            if (mode.value === 'mypage') {
              target = 'MyPageCorpJobFairDetail';
            } else if (mode.value === 'openRecruitment') {
              target = 'MyPageCorpOpenRecruitmentDetail';
            }
            router.push({ name: target, params: { id: ojfId } });
          }
        };

        function afterCreateJobNotice() {
          setTimeout(async () => {
            if (resumeId.value) {
              isSaved = true;
              await ojfCropInterviewProposalCreate();
            } else if (mode.value === 'corpRecruitmentHall') {
              $alert("참가 신청 및 채용공고 등록이 완료되었습니다.");
              isSaved = true;
              router.push({ name: 'MyPageCorpJobFairDetail', params: { id: ojfId } });

            } else {
              $alert("채용공고 등록이 완료되었습니다.");
              isSaved = true;

              let target = 'MatchingJobFairDetail';
              if (mode.value === 'mypage') {
                target = 'MyPageCorpJobFairDetail';
              } else if (mode.value === 'openRecruitment' || mode.value === 'mypageOpenRecruitment') {
                target = 'MyPageCorpOpenRecruitmentDetail';
              }
              router.push({ name: target, params: { id: ojfId } });
            }
            // 모든 후처리 완료 후 저장 비활성화 해제
            saveIsDisabled.value = false;
          }, 1000)
        }

        // 참가신청 정보 확인 후 참가신청 등록
        if (recruitmentData) {
          sessionStorage.removeItem('recruitmentData');

          loadingStore.loading = true;
          jobFairCorpService.ojfCropCreateRecruitmentHall(recruitmentData)
            .then((res) => {
              loadingStore.loading = false;
              afterCreateJobNotice();
            })
            .catch((error) => {
              loadingStore.loading = false;
              $alert("참가 신청 등록이 정상적으로 이루어지지 않았습니다.");
              // 에러 발생 시 저장 비활성화 해제
              saveIsDisabled.value = false;
              return;
            })
        } else {
          afterCreateJobNotice();
        }
      } else {
        $alert("채용공고 등록이 정상적으로 이루어지지 않았습니다.");
        // 실패 시 저장 비활성화 해제
        saveIsDisabled.value = false;
      }
      
    }).catch((error) => {
      loadingStore.loading = false;
      $alert("채용공고 등록이 정상적으로 이루어지지 않았습니다.");
      // 에러 발생 시 저장 비활성화 해제
      saveIsDisabled.value = false;
    });
  };

  const recruitmentData = JSON.parse(sessionStorage.getItem('recruitmentData'));

  // 저장 처리
  if (!isInvalid) {
    createJobNotice(); // 참가 신청 성공 후 채용공고 등록
  } else {
    $toast("error", "올바르게 입력되지 않은 항목이 있습니다.");
    highlightFirstError();
    // 유효성 오류 시 저장 비활성화 해제
    saveIsDisabled.value = false;
  }

}

const clickCancel = async (ojfId, recruitmentHallSeq) => {

  // console.log(recruitmentHallSeq)
  if (mode.value === 'corpRecruitmentHall') {
    const ok = await $confirm(["채용공고 등록을 취소하실 경우", "참가 신청도 같이 취소 됩니다.", "등록을 취소 하시겠습니까?"], "계속 진행하기", "취소");
    if(!ok) {
      $alert("참가 신청 및 채용공고 등록이 취소되었습니다.");
      isSaved = true;
      router.push({name: 'MatchingJobFairDetail', params:{id: ojfId}});

    } else {
      return -1;
    }
  } else if (resumeId.value) {
    // console.log('면접제안 공고 등록 취소')
    $alert("채용공고 등록이 취소되었습니다.");
    isSaved = true;
    if (mode.value === 'mypage') {
      router.push({name: 'MyPageCorpJobFairDetail', params:{id: ojfId}})
    } else if (mode.value === 'openRecruitment' || mode.value === 'mypageOpenRecruitment') {
      router.push({name: 'MyPageCorpOpenRecruitmentDetail', params:{id: ojfId}})
    } else {
      router.push({name: 'MatchingJobFairDetail', params:{id: ojfId}})
    }
  } else {
    // console.log('일반')
    $alert("채용공고 등록이 취소되었습니다.");
    isSaved = true;
    if (mode.value === 'mypage') {
      router.push({name: 'MyPageCorpJobFairDetail', params:{id: ojfId}})
    } else if (mode.value === 'openRecruitment' || mode.value === 'mypageOpenRecruitment') {
      router.push({name: 'MyPageCorpOpenRecruitmentDetail', params:{id: ojfId}})
    } else {
      router.push({name: 'MatchingJobFairDetail', params:{id: ojfId}})
    }
  }
}

// 특수문자 작성 안됨
const filterText = (value) => {
  return value.replace(/[^a-zA-Z0-9ㄱ-ㅎ가-힣\s]/g, ''); // 특수문자 제거
}

const onInputChange = (event, key) => {
  jobNoticeCreate.value[key] = filterText(event.target.value); // 필터링된 값 적용
  if (key === 'jobName') {
    inputError.value.jobName = '' ? '공고 제목을 입력하세요.' : '';
  } else if (key === 'recruitArea') {
    inputError.value.recruitArea = '' ? '모집분야명을 입력하세요.' : '';
  } else if (key === 'specialTreat') {
    inputError.value.specialTreat = '' ? '우대 사항을 입력하세요.' : '';
  }
}

const validateText = (key) => {
  if (key === 'recruitCnt') {
    inputError.value.recruitCnt = '' ? '모집인원을 입력하세요.' : '';
  } else {
    inputError.value.salary = '' ? '급여를 선택하세요.' : '';
  }
}

watch(
    () => jobNoticeCreate.value.schoolGb,
    (newVal) => {
      inputError.value.schoolGb = newVal === '' ? '학력을 선택하세요.' : ''
    }
)

const clearErrorFocus = () => {
  try {
    document.querySelectorAll('.error-focus').forEach(el => el.classList.remove('error-focus'))
  } catch(e){}
}

const focusAndScroll = (el) => {
  if (!el) return
  try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }) } catch(e){}
  try { el.focus && el.focus({ preventScroll: true }) } catch(e){}
  try { el.classList && el.classList.add('error-focus') } catch(e){}
}

const highlightFirstError = () => {
  if (inputError.value.jobName) {
    const el = document.querySelector('.resume-title input')
    focusAndScroll(el)
    return
  }
  if (inputError.value.interests) {
    const el = document.querySelectorAll('.category-wrap')[0]
    focusAndScroll(el)
    return
  }
  if (inputError.value.job) {
    const el = document.querySelectorAll('.category-wrap')[1]
    focusAndScroll(el)
    return
  }
  if (inputError.value.recruitArea) {
    const el = document.querySelector('input[placeholder*="모집분야명"]') || document.querySelector('.table-form .vertical input')
    focusAndScroll(el)
    return
  }
  if (inputError.value.recruitCnt) {
    const el = document.querySelectorAll('.grid.half input')[0]
    focusAndScroll(el)
    return
  }
  if (inputError.value.jobExperience) {
    const el = document.querySelectorAll('.category-wrap')[2]
    focusAndScroll(el)
    return
  }
  if (inputError.value.schoolGb) {
    const el = schoolGbRef.value?.$el || document.querySelector('.table-form .vertical .select')
    focusAndScroll(el)
    return
  }
  if (inputError.value.specialTreat) {
    const el = document.querySelector('input[placeholder*="우대 사항"]')
    focusAndScroll(el)
    return
  }
  if (inputError.value.workArea) {
    const el = residenceAreaRef.value?.$el || document.querySelector('.select')
    focusAndScroll(el)
    return
  }
  if (inputError.value.workType) {
    const el = document.querySelectorAll('.category-wrap')[4]
    focusAndScroll(el)
    return
  }
  if (inputError.value.salary) {
    const el = salaryRef.value?.$el || document.querySelectorAll('.grid.half input')[1]
    focusAndScroll(el)
    return
  }
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <div class="content">
          <div class="record-wrap">
            <div class="sub-title">
              <h3>채용공고 등록</h3>
            </div>
            <p class="mt-xs">{{ mode === 'openRecruitment' ? '기업공채관' : '채용박람회' }}에 등록할 채용공고를 작성하세요. (모든 이력사항은 필수 입력사항입니다.)</p>
            <!-- s: 공고 제목 -->
            <div class="content-inner resume-title">
              <KSAInput v-model="jobNoticeCreate.jobName" @input="(event) => onInputChange(event, 'jobName')" maxLength="50" placeholder="공고 제목을 50자 이내로 입력하세요." />
              <p>
                <small style="color:#E71414;">{{ inputError.jobName }}</small>
              </p>
            </div>
            <!-- e: 공고 제목 -->
            <!-- s: 모집 분야 -->
            <div class="table-form">
              <table class="vertical">
                <colgroup>
                  <col width="20%" />
                  <col />
                </colgroup>
                <tr>
                  <th colspan="2">모집 분야</th>
                </tr>
                <tr>
                  <th><span class="mark">관심 카테고리(최대3개)</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': interest.on}" v-for="interest in data_interests" @click="onClickInterest(interest)">
                        {{ interest.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.interests }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">직무</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': job.on}" v-for="job in data_job" @click="onClickJob(job)">
                        {{ job.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.job }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">모집분야명</span></th>
                  <td>
                    <KSAInput v-model="jobNoticeCreate.recruitArea" @input="(event) => onInputChange(event, 'recruitArea')" maxLength="50" placeholder="모집분야명을 입력하세요. (ex. 경영지원, 마케팅담당, 운영업무, 등)" />
                    <p>
                      <small style="color:#E71414;">{{ inputError.recruitArea }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">모집인원</span></th>
                  <td>
                    <div class="grid half">
                      <KSAInputNumber v-model="jobNoticeCreate.recruitCnt" @input="validateText('recruitCnt')" placeholder="0" maxLength="3" /> 명
                    </div>
                    <p>
                      <small style="color:#E71414;">{{ inputError.recruitCnt }}</small>
                    </p>
                  </td>
                </tr>
              </table>
            </div>
            <!-- e: 모집 분야 -->
            <!-- s: 지원 자격 / 근무조건 -->
            <div class="table-form mt-xs">
              <table class="vertical">
                <colgroup>
                  <col width="20%" />
                  <col />
                </colgroup>
                <tr>
                  <th colspan="2">지원 자격 / 근무조건</th>
                </tr>
                <tr>
                  <th><span class="mark">경력</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': jobExperience.on}" v-for="jobExperience in data_jobExperience" @click="onClickJobExperience(jobExperience)">
                        {{ jobExperience.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.jobExperience }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">학력</span></th>
                  <td>
                    <div class="grid half">
                      <KSASelect ref="schoolGbRef" class="select" v-model="jobNoticeCreate.schoolGb" :options="$gb.SCHOOL_GB" />
                    </div>
                    <p>
                      <small style="color:#E71414;">{{ inputError.schoolGb }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">우대 사항(자격증)</span></th>
                  <td>
                    <KSAInput v-model="jobNoticeCreate.specialTreat" @input="(event) => onInputChange(event, 'specialTreat')" maxLength="50" placeholder="우대 사항은 50자이내로 입력하세요." />
                    <p>
                      <small style="color:#E71414;">{{ inputError.specialTreat }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">근무지역</span></th>
                  <td>
                    <KSASelectResidenceArea
                        class="select"
                        ref="residenceAreaRef"
                        @selectOption1="onSelectedWorkArea1"
                        @selectOption2="onSelectedWorkArea2"
                    />
                    <ul class="grid category-wrap">
                      <li :class="{'active': jobNoticeCreate.workHomeYn === 'Y'}" @click="onClickWorkHomeYn(jobNoticeCreate.workHomeYn)">
                        재택근무 가능
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.workArea }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">근무형태</span></th>
                  <td>
                    <ul class="grid category-wrap">
                      <li :class="{'active': workType.on}" v-for="workType in data_workType" @click="onClickWorkType(workType)">
                        {{ workType.label }}
                      </li>
                    </ul>
                    <p>
                      <small style="color:#E71414;">{{ inputError.workType }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th><span class="mark">급여</span></th>
                  <td>
                    <div class="grid half">
                      <div class="mr-xs select-min">
                        <KSASelect ref="salaryGbRef" class="select" v-model="jobNoticeCreate.salaryGb" :options="$gb.SALARY_GB"/>
                      </div>
                      <KSAInputNumber ref="salaryRef" v-model="jobNoticeCreate.salary" :disabled="jobNoticeCreate.salaryGb === '01'" @input="validateText('salary')" maxLength="6" placeholder="0"/>
                      <span class="ml-xs">만원</span>
                    </div>
                    <p>
                      <small style="color:#E71414;">{{ inputError.salary }}</small>
                    </p>
                  </td>
                </tr>
                <tr>
                  <th>기타 요건</th>
                  <td>
                    <KSACKEditor v-model="jobNoticeCreate.note" container="public"/>
                    <!-- <span :style="{ display: 'flex', justifyContent: 'flex-end', color: (jobNoticeCreate.note && jobNoticeCreate.note.length > 4000) ? 'red' : '' }">{{jobNoticeCreate.note.length}}/4,000자</span> -->
                  </td>
                </tr>
              </table>
            </div>
            <!-- e: 지원 자격 / 근무조건 -->
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrap bottom-btn text-right">
      <div class="inner">
        <div class="flex-wrap">
          <KSASecondaryButton class="gray_button" text="취소" @click="clickCancel(ojfId, recruitmentHallSeq)" />
          <div>
            <KSAPrimaryButton text="등록 완료" @click="saveJobNotice(ojfId)" :disabled="saveIsDisabled"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

@import "../../../../../assets/scss/theme";

hr {
  border: 0;
  height: 1px;
  background-color: $gray-regular_color;
  margin: 40px 0;
}

.select-min {
  .select-wrap {
    width: 30%;
  }
}

.container {
  padding-bottom: 0;
  .content {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    .record-wrap {
      width: 100%;
      margin-right: 0;
      .resume-title {
        padding: 20px 0;
      }
      .table-form {
        table {
          th {
            text-align: left;
          }
        }
      }
    }
  }
  .btn-wrap {
    .inner {
      width: calc(100% - 352px);
      margin: auto;
      padding: 0;
    }
    .flex-wrap {
      justify-content: space-between;
    }
  }
}

:deep(.error-focus),
:deep(.error-focus input) {
  outline: 2px solid #E71414 !important;
  border-color: #E71414 !important;
}

</style>